<template>
    <div v-if="isVisble" class="backdrop">
        <div class="modal-content">
            <div class="p-4">{{ content }}</div>
            <button class="btn btn-secondary" @click="isVisble = !isVisble">{{ closeBtnText }}</button>
        </div>

    </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
    content: {
        type: String,
        default: "",
    },
    isVisibleOnLoad: {
        type: Boolean,
        default: false,
    },
    closeBtnText: {
        type: String,
        default: "Close",
    },
});

const isVisble = ref(props.isVisibleOnLoad);

</script>

<style lang="scss" scoped>
.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    button {
        align-self: end;
        width: fit-content;
    }
}
</style>